
import { computed, inject } from '@nuxtjs/composition-api';
import { Button, Checkbox, FormElement, InputButton, Note, Textarea, Toggle } from '05-ui-kit';
import type { PartialDeep } from 'type-fest';
import type { CheckoutCoupon, CheckoutDelivery, CheckoutTotal } from '~/type/Checkout';
import type { NewOrder } from '~/type/NewOrder';
import type { ResponseError } from '~/type/Error';
import type { EmitteryType } from '~/plugins/emitter';
import WriteOffBonusesInfo from '~/components/WriteOffBonuses/WriteOffBonusesInfo.vue';
import UIActionList from '~/data/UIActionList/UIActionList.vue';
import { useUserStore } from '~/store/user';
import WriteOffBonuses from '~/components/WriteOffBonuses/WriteOffBonuses.vue';
interface FormSubmitParams {
  changeStatus: ({
    status,
    action
  }: {
    status: string;
    action: string;
  }) => void;
}
const __sfc_main = {};
__sfc_main.props = {
  value: {
    key: "value",
    required: false,
    type: null
  },
  delivery: {
    key: "delivery",
    required: false,
    type: null
  },
  total: {
    key: "total",
    required: true,
    type: null
  },
  couponList: {
    key: "couponList",
    required: false,
    type: Array,
    default: () => []
  },
  errors: {
    key: "errors",
    required: false,
    type: Array
  },
  apiError: {
    key: "apiError",
    required: false,
    type: null
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  isUnavailableExist: {
    key: "isUnavailableExist",
    required: false,
    type: Boolean,
    default: false
  },
  button: {
    key: "button",
    required: false,
    type: Boolean,
    default: true
  },
  hideCommentFieldOnMobile: {
    key: "hideCommentFieldOnMobile",
    required: false,
    type: Boolean,
    default: false
  },
  hidePrivacyPolicyOnMobile: {
    key: "hidePrivacyPolicyOnMobile",
    required: false,
    type: Boolean,
    default: false
  },
  isAvailableBonusesPay: {
    key: "isAvailableBonusesPay",
    required: false,
    type: Boolean,
    default: false
  },
  isPrivacyPolicyChecked: {
    key: "isPrivacyPolicyChecked",
    required: true,
    type: Boolean
  },
  isShowCallbackCheckbox: {
    key: "isShowCallbackCheckbox",
    required: false,
    type: Boolean,
    default: false
  },
  isPreOrder: {
    key: "isPreOrder",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const emitter = inject<EmitteryType>('emitter')!;
  const userStore = useUserStore();
  const isProceedCheckout = computed(() => {
    if (props.isPreOrder && props.total.quantity) return false;else return !props.total.quantity || props.total.price.total === 0;
  });

  /**
   * мы вычитаем -1 из максимально возможного кол-ва списываемых бонусов чтобы хотя один рубль,
   * но человек должен был оплатить при полной оплате заказа бонусами
  */
  const allowBonusAmountToSpend = computed(() => {
    const totalPrice = props.total.price.total + (props.value?.delivery?.type?.price || 0);
    if (totalPrice < props.total.bonus.available) return Math.max(totalPrice - 1, 0);else return props.total.bonus.available;
  });
  const isUser = computed(() => userStore.isUser);
  const isCheckOrder = computed(() => {
    if (props.total.quantity && props.isPrivacyPolicyChecked) return true;else if (!props.total.quantity || props.total.price.total === 0) return false;
  });
  function onChange(data: {
    [key: string]: any;
  }) {
    emit('change-data', {
      ...props.value?.summary,
      ...data
    });
  }
  function onPromocodeSuccessAdd() {
    emit('coupon-change');
    emitter.emit('apply-promocode', {
      status: 'success',
      discount: props.total?.price?.discount
    });
  }
  function onPromocodeSuccessRemove({
    changeStatus
  }: FormSubmitParams) {
    emit('coupon-change');
    changeStatus({
      action: 'add',
      status: 'initial'
    });
  }
  return {
    emit,
    emitter,
    isProceedCheckout,
    allowBonusAmountToSpend,
    isUser,
    isCheckOrder,
    onChange,
    onPromocodeSuccessAdd,
    onPromocodeSuccessRemove
  };
};
__sfc_main.components = Object.assign({
  WriteOffBonuses,
  WriteOffBonusesInfo,
  UIActionList,
  FormElement,
  InputButton,
  Toggle,
  Textarea,
  Note,
  Button,
  Checkbox
}, __sfc_main.components);
export default __sfc_main;
